<template>
  <div
    class="base-form p-0"
    :class="{
      expanded: expanded && !collapsed,
    }"
  >
    <div class="deliveries-header" @click="onCollapseToggle">
      <h2 class="text-center py-2" style="color: black">{{ title }}</h2>
      <img
        class="arrow float-right"
        :class="collapsed ? 'arrow--active' : ''"
        :src="asset('imgs/icons/double-arrow-black.svg')"
        alt="sidebar-arrow"
        width="14"
        height="12"
      />
    </div>
    <div class="dispatch-table-container">
      <b-row v-if="collapsed && (statusCount(0) > 0 || statusCount(1) > 0)">
        <b-col cols="12" class="pl-4 mb-2">
          <div
            v-if="statusCount(0) > 0"
            class="dispatch-status d-inline-block dispatch-status--red"
          />
          <span v-if="statusCount(0) > 0" class="ml-2">
            {{ statusCount(0) }} Late
          </span>
          <div
            v-if="statusCount(1) > 0"
            class="dispatch-status d-inline-block ml-4 dispatch-status--yellow"
          />
          <span v-if="statusCount(1) > 0" class="ml-2">
            {{ statusCount(1) }} At Risk
          </span>
        </b-col></b-row
      >
      <b-table
        v-if="!collapsed"
        hover
        no-local-sorting
        small
        :items="data"
        :fields="deliveryOptions"
        @row-clicked="onRowClicked"
      >
        <template #cell(info)="row">
          <div
            :id="'delivery' + row.item.network.name + title + row.item.id"
            class="dispatch-status"
            :class="statusClass(row.item.dispatch_status)"
          />
          <b-tooltip
            :target="'delivery' + row.item.network.name + title + row.item.id"
            triggers="hover"
            placement="bottomright"
            custom-class="table-tooltip"
          >
            <div class="text-left">
              <span> <b>Status:</b> {{ row.item.status }} </span><br />
              <span> <b># Orders:</b> {{ row.item.order_count }} </span><br />
              <span>
                <b>Facility Ready Time:</b>
                {{ row.item.facility_ready_time | formatDateTimeNoYear }}
              </span>
              <br />
              <span>
                <b>Fulfillment Time:</b>
                {{ row.item.fulfillment_time | formatDateTimeNoYear }}
              </span>
              <br />
              <span> <b>Contact:</b> {{ row.item.contact_name }}</span>
              <br />
              <span> <b>Phone:</b> {{ row.item.contact_phone }}</span>
              <br />
              <span> <b>Email:</b> TODO</span>
              <br />
              <span> <b>Network:</b> {{ row.item.network.name }}</span> <br />
              <span>
                <b>Address:</b>
                {{ row.item.address | formatAddressStreet }}</span
              >
              <br />
            </div>
          </b-tooltip>
        </template>
        <template #cell(id)="row">
          <router-link :to="`/deliveries/${row.item.id}`" target="_blank">
            {{ row.item.id }}
          </router-link>
        </template>
        <template #cell(deliveryProvider)="row">
          {{ row.item.delivery_provider.name }}
        </template>
        <template #cell(fulfillment_time)="row">
          {{ row.item.fulfillment_time | formatDateTimeNoYear }}
        </template>
      </b-table>
    </div>
    <b-row align-h="between">
      <b-col class="pl-4">
        <p v-if="!collapsed" class="table-results my-2">
          Displaying {{ paginationFrom }}-{{ paginationTo }} of
          {{ rows }} results
        </p>
      </b-col>
      <b-col v-if="rows > queryFilters.limit" class="pr-4 mt-2">
        <b-pagination
          v-model="page"
          class="float-right"
          :total-rows="rows"
          :per-page="queryFilters.limit"
          aria-controls="my-table"
          @input="onPaginate"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ResourceAPI from '../../services/ResourceAPI';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    statuses: {
      type: String,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      rows: 0,
      page: 1,
      paginationFrom: null,
      paginationTo: null,
      queryFilters: {},
      busy: true,
      deliveryOptions: [
        {
          key: 'info',
          label: '',
          sortable: false,
          thStyle: { width: '40px' },
        },
        {
          key: 'id',
          label: 'Delivery ID',
          sortable: false,
          thStyle: { width: '85px' },
        },
        {
          key: 'fulfillment_time',
          label: 'Fulfillment Time',
          sortable: false,
          thStyle: { width: '125px' },
        },
        {
          key: 'deliveryProvider',
          label: 'Delivery Provider',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters('session', ['filters']),
  },
  mounted() {
    this.setStoreFilters();
    this.onPaginate(this.page);
  },
  methods: {
    onCollapseToggle() {
      this.$emit('collapseToggled');
    },
    statusClass(item) {
      return {
        'dispatch-status--green': item === 2,
        'dispatch-status--yellow': item === 1,
        'dispatch-status--red': item === 0,
      };
    },
    setStoreFilters() {
      this.queryFilters = {
        network: this.filters.network ? this.filters.network : null,
        provider: this.filters.provider ? this.filters.provider : null,
        facility: this.filters.hub ? this.filters.hub : null,
        dispatchStatus: this.filters.status ? this.filters.status : null,
        number: this.filters.number ? this.filters.number : null,
        delivery: this.filters.delivery ? this.filters.delivery : null,
        limit: this.filters.limit ? this.filters.limit : 50,
        sort: this.filters.sort ? this.filters.sort : '',
        dir: this.filters.dir ? this.filters.dir : '',
      };

      this.range = {
        ...this.filters.range,
      };
    },
    onPaginate(page) {
      this.page = page;
      this.loadResults();
    },
    onSortingChanged(ctx) {
      this.queryFilters.sort = ctx.sortBy;
      this.queryFilters.dir = ctx.sortDesc ? 'DESC' : 'ASC';
      this.loadResults();
    },
    applyFilters() {
      this.queryFilters.page = 1;
      this.loadResults();
    },
    loadResults() {
      const me = this;

      me.busy = true;

      this.setStoreFilters();

      // Format search params for query
      const searchParams = {
        ...this.queryFilters,
        range: this.range,
        page: this.page,
      };
      searchParams.order = searchParams.order ? searchParams.order : null;
      searchParams.delivery = searchParams.delivery
        ? searchParams.delivery
        : null;
      searchParams.dispatchStatus = searchParams.dispatchStatus
        ? searchParams.dispatchStatus.value
        : null;
      searchParams.fulfillmentCenter = searchParams.kitchen
        ? searchParams.kitchen.id
        : null;
      searchParams.network = searchParams.network
        ? searchParams.network.id
        : null;
      searchParams.deliveryProvider = searchParams.provider
        ? searchParams.provider.id
        : null;
      searchParams.facility = searchParams.facility
        ? searchParams.facility.id
        : null;
      searchParams.with = 'address,deliveryProvider,network';
      searchParams.start = me.formatDateFilter(searchParams.range.start);
      searchParams.end = me.formatDateFilter(searchParams.range.end);
      searchParams.range = null;
      searchParams.kitchen = null;
      searchParams.provider = null;

      // Filter down to set status
      searchParams.statuses = this.statuses;
      searchParams.excludeSource = 'zdm-test';

      return ResourceAPI.getRecords('dispatch/deliveries', searchParams)
        .then((data) => {
          me.rows = data.meta.total;
          me.data = data.data;
          me.paginationFrom = data.meta.from;
          me.paginationTo = data.meta.to;
          me.busy = false;
        })
        .catch((error) => alert(error));
    },

    onRowClicked(record) {
      this.page = 1;
      this.$emit('filterDelivery', record.id);
    },

    statusCount(status) {
      return this.data.filter((delivery) => {
        return delivery.dispatch_status === status;
      }).length;
    },
  },
};
</script>
